/**
 * Nebula Background Component
 *
 * Magischer Nebel-Hintergrund mit animierten Blobs
 */

import { cn } from '@/lib/utils';
import { nebulaBlobs } from './animations';

export interface NebulaBackgroundProps {
  theme: 'light' | 'dark';
}

export function NebulaBackground({ theme }: NebulaBackgroundProps) {
  return (
    <div className="absolute inset-0 overflow-hidden">
      {nebulaBlobs.map((blob, i) => (
        <div
          key={i}
          className={cn('absolute rounded-full', blob.blur)}
          style={{
            width: blob.width,
            height: blob.height,
            ...(blob.left && { left: blob.left }),
            ...(blob.right && { right: blob.right }),
            ...(blob.top && { top: blob.top }),
            ...(blob.bottom && { bottom: blob.bottom }),
            background: theme === 'dark' ? blob.gradientDark : blob.gradientLight,
            animation: blob.animation,
          }}
        />
      ))}
    </div>
  );
}
